import dayjs from 'dayjs';

export const resolveStartedAtFilterBounds = ({
  startDay,
  endDay,
}: {
  startDay: string | null;
  endDay: string | null;
}): { startAt: string | null; endAt: string | null } => ({
  startAt: startDay ? dayjs(startDay).startOf('day').toISOString() : null,
  endAt: endDay ? dayjs(endDay).endOf('day').toISOString() : null,
});
